<template>
  <v-menu
    offset-y
    left
    nudge-bottom="14"
    min-width="230"
    content-class="user-profile-menu-content"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-badge
        bottom
        color="success"
        overlap
        offset-x="12"
        offset-y="12"
        class="ms-4"
        dot
      >
        <v-avatar
          size="40px"
          v-bind="attrs"
          color="primary"
          class="v-avatar-light-bg primary--text"
          v-on="on"
        >
          <v-img :src="require('@/assets/images/avatars/1.png')"></v-img>
        </v-avatar>
      </v-badge>
    </template>
    <v-list>
      <div class="pb-3 pt-2">
        <v-badge
          bottom
          color="success"
          overlap
          offset-x="12"
          offset-y="12"
          class="ms-4"
          dot
        >
          <v-avatar
            size="40px"
            color="primary"
            class="v-avatar-light-bg primary--text"
          >
            <v-img :src="require('@/assets/images/avatars/1.png')"></v-img>
          </v-avatar>
        </v-badge>
        <div
          class="d-inline-flex flex-column justify-center ms-3"
          style="vertical-align:middle"
        >
          <span class="text--primary font-weight-semibold mb-n1">
            {{ loggedUserData.username }}
          </span>
          <small class="text--disabled text-capitalize mx-auto">{{ roleLabel }}</small>
        </div>
      </div>

      <v-divider></v-divider>

      <!-- Profile -->
      <router-link
        to="/profile"
        class="d-flex align-center text-decoration-none"
      >
        <v-list-item href="#">
          <v-list-item-icon class="me-2">
            <v-icon size="22">
              {{ icons.mdiAccountOutline }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Perfil</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </router-link>

      <!-- Lab config -->
      <router-link
        v-if="userLabProfile.role && userLabProfile.role.id === 5"
        to="/lab-settings"
        class="d-flex align-center text-decoration-none"
      >
        <v-list-item href="#">
          <v-list-item-icon class="me-2">
            <v-icon size="22">
              {{ icons.mdiCogOutline }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Personalizar laboratorio</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </router-link>

      <v-divider class="my-2"></v-divider>

        <v-list-item v-if="canChangeLab" @click="volverSeleccionarLab" >
          <v-list-item-icon class="me-2">
            <v-icon size="22">
              {{ icons.mdiSwapHorizontal }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Cambiar laboratorio</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      <v-divider class="my-2"></v-divider>

      <!-- Logout -->
      <v-list-item @click="logoutUser">
        <v-list-item-icon class="me-2">
          <v-icon size="22">
            {{ icons.mdiLogoutVariant }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Salir</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import {
  mdiAccountOutline,
  mdiEmailOutline,
  mdiCheckboxMarkedOutline,
  mdiChatOutline,
  mdiCogOutline,
  mdiCurrencyUsd,
  mdiHelpCircleOutline,
  mdiLogoutVariant,
  mdiSwapHorizontal
} from '@mdi/js'

export default {
  name: 'AppBarUserMenu',
  methods: {
    async logoutUser() {
      this.$store.dispatch('session/logoutUser')
      this.$router.push('/login')
    },

    volverSeleccionarLab() {
      this.$store.dispatch('session/setUserLabProfile', null)
      localStorage.removeItem('user_lab_profile')
      this.$router.push('/select-laboratory')
    },

  },
  created() {
  },
  computed: {
    loggedUserData() {
      return this.$store.getters["session/userData"]();
    },
    userLabProfile() {
      return this.$store.getters["session/selectedLaboratory"]();
    },
    roleLabel() {
      return this.userLabProfile?.role?.label || 'Sin rol';
    },
    laboratoryName() {
      return this.userLabProfile?.laboratory_name || '';
    },
    canChangeLab() {
      const session = JSON.parse(sessionStorage.getItem('session'))
      return session?.user?.laboratory_profiles?.length > 1
    },
  },
  setup() {
    return {
      icons: {
        mdiAccountOutline,
        mdiEmailOutline,
        mdiCheckboxMarkedOutline,
        mdiChatOutline,
        mdiCogOutline,
        mdiCurrencyUsd,
        mdiHelpCircleOutline,
        mdiLogoutVariant,
        mdiSwapHorizontal
      },
    }
  },
}
</script>

<style lang="scss">
.user-profile-menu-content {
  .v-list-item {
    min-height: 2.5rem !important;
  }
}
</style>
